import clsx from "clsx";
import { BaseHit, Hit } from "instantsearch.js";
import Link from "next/link";
import { FC, useEffect, useMemo, useRef } from "react";
import { useStats } from "react-instantsearch";
import { pagesPath } from "@/lib/$path";
import { AlgoliaTechBlog } from "@/lib/algolia";
import { BodyHighlight } from "../BodyHighlight/BodyHighlight";

interface Props {
  hit: Hit<BaseHit & AlgoliaTechBlog>;
  selected: boolean;
  onClick?: () => void;
}

export const HitComponent: FC<Props> = ({ hit, selected, onClick }) => {
  const { query } = useStats();
  const linkRef = useRef<HTMLAnchorElement>(null);

  const keywords = useMemo(() => (query ? query.trim().split(/ +/g) : []), [query]);

  useEffect(() => {
    if (selected && linkRef.current) {
      typeof linkRef.current.scrollIntoViewIfNeeded !== "undefined"
        ? linkRef.current.scrollIntoViewIfNeeded()
        : linkRef.current.scrollIntoView();
    }
  }, [selected]);

  return (
    <Link
      id={hit.objectID}
      ref={linkRef}
      href={pagesPath.kdotdev._slug(hit.slug).$url()}
      className="flex"
      onClick={onClick}
    >
      <div className={clsx(selected && "bg-[#EEE]", "flex flex-1 flex-col gap-3 py-3 pl-2")}>
        <BodyHighlight attribute="title" hit={hit} className="text-[16px]" keywords={keywords} />
        <div className=" flex">
          {hit.tags?.map((tag, index) => (
            <span key={tag.id} className="!text-[14px] text-[#999]">
              {index > 0 && <span className="mx-1">/</span>}
              <BodyHighlight attribute={`tags.${index}.name`} hit={hit} keywords={keywords} />
            </span>
          ))}
        </div>
        <BodyHighlight
          className="line-clamp-2 text-[16px]"
          attribute="body"
          hit={hit}
          keywords={keywords}
          hiddenWhenNoMatch
        />
      </div>
    </Link>
  );
};
